module.exports = __webpack_public_path__ + "static/peter-2158717c850a655dc6b5d789d516b9d7.png";